import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Calendar, Headphones } from 'lucide-react';
import { Link } from 'react-router-dom';
import BookConsultModal from './BookConsultModal';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once on mount to set initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'Managed IT', href: '/managed-it' },
    { label: 'Services', href: '/services' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Contact', href: '/contact' },
    { label: 'Referrals', href: '/referrals' },
    { label: 'About Us', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 flex-shrink-0">
            <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">M</span>
            </div>
            <span className="text-lg font-semibold text-gray-900 whitespace-nowrap">
              Microsystems Networking
            </span>
          </Link>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-1 flex-shrink-0">
            {navItems.map((item) => (
              item.href.startsWith('#') ? (
                <a
                  key={item.label}
                  href={item.href}
                  className="px-2.5 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  className="px-2.5 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center flex-shrink-0 ml-4 gap-3">
            <a
              href="https://support.microsystemsnetworking.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
              data-testid="header-support-link"
            >
              <Headphones className="w-4 h-4 mr-1" />
              Client Support
            </a>
            <Button 
              className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4"
              onClick={() => setShowModal(true)}
              data-testid="book-consult-button"
            >
              <Calendar className="w-4 h-4 mr-1" />
              Book a Free Consult
            </Button>
          </div>
        </div>
      </div>
      <BookConsultModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </header>
  );
};

export default Header;